import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {fieldError, fieldErrors} from '../../shared/invoicing.service';
import {QuoteService} from '../../shared/quote.service';
import {QUOTE_TEXTS, QuoteSettings} from '../../interfaces/quote';

/** The tenant's quote settings (#1697), Admin only: default validity and the standard texts per language. */
@Component({
  selector: 'bst-quote-settings',
  templateUrl: './quote-settings.component.html',
  styleUrls: ['../invoicing-client/invoicing-form.scss', './quote-settings.component.scss'],
  standalone: false
})
export class QuoteSettingsComponent implements OnInit {
  readonly slots = QUOTE_TEXTS;
  settings: QuoteSettings = null;
  locale = 'nl';
  errors: Record<string, string[]> = {};
  busy = false;
  private saved: string = null;

  constructor(private quotes: QuoteService, private translate: TranslateService) {}

  async ngOnInit() {
    this.settings = await this.quotes.getSettings().catch(() => null);
    this.saved = JSON.stringify(this.settings);
  }

  // The server sends every language it prints, in its own order.
  get locales(): string[] {
    return Object.keys(this.settings?.texts ?? {});
  }

  error(field: string): string | null {
    return fieldError(this.translate, this.errors, field);
  }

  get isDirty(): boolean {
    return !!this.settings && JSON.stringify(this.settings) !== this.saved;
  }

  async save() {
    if (this.busy) { return; }
    this.busy = true;
    this.errors = {};
    const saved = await this.quotes.saveSettings(this.settings).catch(e => { this.errors = fieldErrors(e); return null; });
    this.busy = false;
    if (saved) { this.settings = saved; this.saved = JSON.stringify(saved); }
  }
}
